import React, { FC, useState } from 'react';
import { useParams } from 'react-router';
import { UrlParams } from 'src/modules/shared/types';
import { useGetTableOfContentQuery } from 'src/store/table-of-contents/tableOfContentsApi';
import { Skeleton } from '@material-ui/lab';
import { TOCImage } from './TableOfContentsImageStyled';

export const TableOfContentsImage: FC = () => {
  let params = useParams<UrlParams>();
  const { bookId } = params;
  const { data } = useGetTableOfContentQuery(bookId ?? '', { skip: !bookId });
  const [imageIsLoaded, setImageIsLoaded] = useState<boolean>(false);

  return (
    <>
      {!imageIsLoaded && <Skeleton variant="rect" height={300} style={{ borderRadius: '16px' }} />}

      <TOCImage
        loaded={imageIsLoaded}
        src={data?.coverImage}
        alt={`Book cover for ${data?.title}`}
        onLoad={() => setImageIsLoaded(true)}
      />
    </>
  );
};
